import { render } from "./AppleIcon.vue?vue&type=template&id=3e69c8e3"
const script = {}
script.render = render

export default script